import { createSlice } from "@reduxjs/toolkit";

export const offerSlice = createSlice({
  name: "offer",
  initialState: {
    list: [],
    meta: {},
    offerDetails: {},
    callToActions: [],
  },
  reducers: {
    createOfferRequest: () => {},
    getOffersListRequest: () => {},
    getOffersListResponse: (state, action) => {
      state.list = action.payload.offers;
      state.meta = action.payload.meta;
    },
    getOfferDetailsRequest: () => {},
    getOfferDetailsResponse: (state, action) => {
      state.offerDetails = action.payload;
    },
    deleteOfferRequest: () => {},
    publishOfferRequest: () => {},
    editHotOfferStatusRequest: () => {},
    editServiceOfferStatusRequest: () => {},
    editOfferRequest: () => {},
    editOfferResponse: (state, action) => {
      state.offerDetails = action.payload;
    },
    getCallToActionsRequest: () => {},
    getCallToActionsResponse: (state, action) => {
      state.callToActions = action.payload.callToActions;
    },
  },
});

export const {
  createOfferRequest,
  getOffersListRequest,
  getOffersListResponse,
  getOfferDetailsRequest,
  getOfferDetailsResponse,
  deleteOfferRequest,
  editOfferRequest,
  editOfferResponse,
  publishOfferRequest,
  getCallToActionsRequest,
  getCallToActionsResponse,
  editHotOfferStatusRequest,
  editServiceOfferStatusRequest
} = offerSlice.actions;
export default offerSlice.reducer;
